import useBrandInfo from "@hooks/dataHooks/useBrandInfo"
import useInteractive from "@hooks/useInteractive"
import {
  cookiePolicyURL,
  privacyPolicyURL,
  sitemapURL,
  termsAndConditionsURL,
} from "@lib/urls"
import { getWhatsAppURL } from "@lib/utils"
import loadable from "@loadable/component"
import { Link, graphql, useStaticQuery } from "gatsby"
import React,{useEffect, useState, useRef} from "react"
import { Accordion, Container } from "react-bootstrap"
import "./Footer.scss"
// import { useGlobalStore } from "@stores/globalStore"
import useDeviceMedia from "@hooks/useDeviceMedia"
import { CurrencyTypeSelect, SizeTypeSelect } from "@components/SearchResults/SearchFilters/filterElements"
import CTALink from "@components/elements/CTALink"
import SizeTypeSelector from "@components/SizeTypeSelector/SizeTypeSelector"
import { usePropertyStore } from "@components/SearchResults/store/propertyStore"
import GPTW from "@components/icons/GPTW"
const CookieConsent = loadable(() => import("react-cookie-consent"))
const FooterNewsLetterModule = loadable(() => import("@components/FooterNewsLetterModule/FooterNewsLetterModule"))
const FacebookIcon = loadable(() => import("@components/icons/FacebookIcon"))
const InstagramIcon = loadable(() => import("@components/icons/InstagramIcon"))
const LinkedInIcon = loadable(() => import("@components/icons/LinkedInIcon"))
const TelegramIcon = loadable(() => import("@components/icons/TelegramIcon"))
const TwitterIcon = loadable(() => import("@components/icons/TwitterIcon"))
const WhatsAppIcon = loadable(() => import("@components/icons/WhatsAppIcon"))
const YoutubeIcon = loadable(() => import("@components/icons/YoutubeIcon"))
const Footer = (props) => {
  const { isTablet, isMobile } = useDeviceMedia()
  const data = useStaticQuery(graphql`
    query {
      strapiGlobalMenu {
        footer_links {
          title
          id
          ctas {
            ...ctaFragment
          }
        }
      }
    }
  `)
const searchResult = usePropertyStore((state) => state.searchResult)
  const { hasInteracted } = useInteractive()

  const footerLinks = data?.strapiGlobalMenu?.footer_links

  const {
    facebookLink,
    twitterLink,
    instagramLink,
    linkedinLink,
    ornNo,
    youtubeLink,
    telegramLink,
    phone,
    whatsapp,
  } = useBrandInfo()

  const currentYear = new Date().getFullYear()

  const [showModal, setShowModal] = useState(false)
  // const { currencyType, language } = useGlobalStore()
  const [tog, setTog] = useState(false)
  const openToggle = () => {
    setTog(!tog)
    setShowModal(false)
  }
  // useEffect(() => {
  //   setTog(false)
  // }, [currencyType, language])
  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setTog(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  return (
    <>
    {!props?.hideNewsletter &&<FooterNewsLetterModule isFooter />}
    <div className="footer-wrap section-p">
      {/* {hasInteracted && ( */}
        <Container className="footer-container">
        
                      <div className="d-flex justify-content-between">
                      {/* <div className="divider" /> */}
          <div className="footer-cta-section-wrap d-none d-xl-grid">
           
            {footerLinks.map((item) => (
              <div className="footer-cta-section" key={item.id}>
                <p className="title">{item.title}</p>
                <div className="cta-section">
                  {item.ctas.map((cta) => (
                    <CTALink key={cta.id} cta={cta} className="cta" />
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="footer-cta-section-wrap settings d-block d-xl-none">
            <div className="footer-cta-section">
            <p className="title setting">Settings</p>
            <div className="footer-opt">
                <CurrencyTypeSelect setTog={setTog} tog={tog} isFooter />
                <SizeTypeSelect setTog={setTog} tog={tog}/>
                {/* <div className="label">Language</div>
                <LanguageTypeSelect setTog={setTog} tog={tog} /> */}
              </div>
          </div>
          </div>
          </div>
          <div className="footer-cta-section-wrap d-block d-xl-none">
          <Accordion className="footer-cta-section">
            {footerLinks?.map((item) => (
              <Accordion.Item eventKey={item.id} key={item.id}>
                <Accordion.Header as="p" className="title">{item.title}</Accordion.Header>
                <Accordion.Body className="cta-section">
                {item.ctas.map((cta) => (
                    <CTALink key={cta.id} cta={cta} className="cta" />
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
          </div>
          <div className="divider d-none d-md-block" />
          <div className="footer-bottom-section">
          <div className="footer-cta-section-wrap settings d-none d-xl-block">
            <div className="footer-cta-section">
            <p className="title setting">Settings</p>
            <div className="footer-opt">
                <CurrencyTypeSelect setTog={setTog} tog={tog} isFooter />
                <SizeTypeSelect setTog={setTog} tog={tog}/>
                {/* <div className="label">Language</div>
                <LanguageTypeSelect setTog={setTog} tog={tog} /> */}
              </div>
          </div>
          </div>
         
            
          <div className="bottom-section new-logo-gptw">
              <div className="gptw">
                <Link to="/blog/provident-estate-great-place-to-work-certification/"><GPTW /></Link>
                <div className="d-block d-md-none">
                  <p>Provident Estate is proud to announce that we are now officially certified as a Great Place to Work®</p>
                </div>
              </div>
              <div className="no-top">
            <div className="socials-section">
              <a href={facebookLink} target="_blank" rel="noreferrer">
                <FacebookIcon />
              </a>
              <a href={twitterLink} target="_blank" rel="noreferrer">
                <TwitterIcon />
              </a>
              <a href={instagramLink} target="_blank" rel="noreferrer">
                <InstagramIcon />
              </a>
              <a href={linkedinLink} target="_blank" rel="noreferrer">
                <LinkedInIcon />
              </a>
              <a href={youtubeLink} target="_blank" rel="noreferrer">
                <YoutubeIcon outline />
              </a>
              <a href={telegramLink} target="_blank" rel="noreferrer">
                <TelegramIcon />
              </a>
              <a
                // href={getWhatsAppURL(whatsapp)}
                // href="#"
                target="_blank"
                rel="noreferrer"
                className="wa-icon"
                id="openbot"
              >
                <WhatsAppIcon outline color="white" />
              </a>
            </div>
              <div className="terms-section">
                <Link to={privacyPolicyURL}>Privacy Policy</Link>
                <span>/</span>
                <Link to={termsAndConditionsURL}>Terms & Conditions</Link>
                <span>/</span>
                <Link to={sitemapURL}>Sitemap</Link>
              </div>
              <div className="copyright-section">
                <p>Copyright © {currentYear}. Provident Real Estate</p>
                <span>|</span>
                <p className="">
                  ORN No:
                  <span className="orn-no">{ornNo}</span>
                </p>
                                
              </div>
              <div className="copyright-section">
              <p>PROVIDENT® is a registered trademark since 2008</p>
              </div>
              <p className="site-by">
                Site by{" "}
                <a
                  rel="nofollow"
                  href="https://www.starberry.tv"
                  target="_blank"
                  // rel="noreferrer"
                  className="site-by-name"
                >
                  Starberry
                </a>
              </p>
            </div>
          </div>
          </div>
        </Container>
      {/* )} */}
      {/* {searchResult?.nbHits && ( */}
         <CookieConsent
          location="bottom"
          buttonText="Accept Cookies"
          cookieName="CookiePolicy"
          expires={365}
        >
          <div className="cookie-wrap">
            <p>
              We have placed cookies on your device to help make this website
              better. <span className="d-none d-md-inline">By continuing, you agree to our{" "}</span>
              <Link className="d-none d-md-inline" to={cookiePolicyURL}>Cookie Policy</Link>.
            {" "}
            </p>
            <button
              className="button button-orange d-block"
              onClick={() => {
                const acceptButton =
                  document.getElementById("rcc-confirm-button")
                if (acceptButton) {
                  acceptButton.click()
                }
              }}
            >
              Accept Cookies
            </button>
          </div>
        </CookieConsent>
       {/* )}  */}
    </div>
    </>
  )
}

export default Footer